import axios from 'axios'

import store from '@/store/store';
import { RootMutations } from '@/store/types/mutation-types';
import { combineSignals } from '@/bundles/Http/utils/combineSignals';

import versionSetup from '../helpers/interceptors'
import { resetTokenAndReattempRequest } from './refresh'

const instance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.VUE_APP_V1_API_URL,
})

instance.interceptors.response.use(
  async (response) => {
    return response
  },
  (error) => {
    return resetTokenAndReattempRequest(error)
  }
)

instance.interceptors.response.use(versionSetup, (error) => {
  return Promise.reject(error)
})

instance.interceptors.request.use((config) => {
  if (config.method?.toLowerCase() === 'get') {
    const controller = new AbortController();
    const persistOnRouteChange = config.options?.persistOnRouteChange || false;

    store.commit(RootMutations.ADD_CANCEL_TOKEN, {
      controller,
      persistOnRouteChange,
    });

    config.signal = config.signal
      ? combineSignals([config.signal, controller.signal])
      : controller.signal;
  }

  return config;
});

export default instance;
